import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import {
  CircleExclamationSolidIcon,
  CircleXmarkSolidIcon
} from '../../shared/icons/icons';

import { ProductData } from '../../shared/types/graphql-types';
import { ARTICLE_STATUSES } from '../../shared/constants/products';

import styles from './product-article-status-banner.one-dt.scss';

interface ProductArticleStatusBannerProps {
  product: ProductData;
  showBoxDesign?: boolean;
}

function ProductArticleStatusBanner(props: ProductArticleStatusBannerProps) {
  const {
    product: { articleStatus, articleStatusLabel, productLaunchDate } = {},
    showBoxDesign = false
  } = props;
  return (
    <div
      className={cn(
        styles['container'],
        'product-article-status-banner__container',
        showBoxDesign && styles['box-design-container']
      )}
    >
      {(articleStatus === ARTICLE_STATUSES.DISCONTINUED ||
        articleStatus === ARTICLE_STATUSES.BACKORDER ||
        articleStatus === ARTICLE_STATUSES.QUALITY_HOLD ||
        articleStatus === ARTICLE_STATUSES.TEMPORARILY_UNAVAILABLE) && (
        <span
          className={
            showBoxDesign ? styles['box-design-icon-discontinued'] : ''
          }
        >
          <CircleXmarkSolidIcon
            className={cn(
              styles['icon-discontinued'],
              'product-article-status-banner__icon-discontinued'
            )}
          />
        </span>
      )}
      {articleStatus === ARTICLE_STATUSES.PRE_LAUNCH && (
        <span
          className={showBoxDesign ? styles['box-design-icon-prelaunch'] : ''}
        >
          <CircleExclamationSolidIcon
            className={cn(
              styles['icon-prelaunch'],
              'product-article-status-banner__icon-prelaunch'
            )}
          />
        </span>
      )}
      <Typography
        className={cn(
          'product-article-status-banner__label',
          showBoxDesign && styles['box-design-text']
        )}
        tag="div"
      >{`${articleStatusLabel}${
        productLaunchDate && articleStatus === ARTICLE_STATUSES.PRE_LAUNCH
          ? `: ${productLaunchDate}`
          : ''
      }`}</Typography>
    </div>
  );
}

export default ProductArticleStatusBanner;
